import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import BuildCreative from 'features/creative/add/build/BuildCreative'
import { useDispatch, useSelector } from 'react-redux'
import { reset, selectChannel } from 'features/creative/add/creativeAddSlice'
import api from 'api/axios/foka'
import { importCreative } from 'features/creative/add/import/creativeImportSlice'
import { DashboardTypes } from 'features/Codes'
import { setChannel } from '../../creative/add/build/buildCreativeSlice'

const SaveAsCreative = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { campaignId, adGroupId, creativeId } = useParams()
  const { accountId: adAccountId } = useParams()
  const { channel } = useSelector(state => state.ad.groupCreative)
  useEffect(() => {
    if (creativeId && channel) {
      ;(async () => {
        const {
          data: { creative },
        } = await api.creative.getCreative(creativeId)
        dispatch(selectChannel(channel))
        await importCreative({
          creative,
          channel,
          dispatch,
        })
      })()
    }
  }, [creativeId, channel, dispatch])
  useEffect(() => {
    dispatch(setChannel(channel))
  }, [dispatch, channel])
  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )
  return (
    <BuildCreative
      saveAs
      adGroupId={adGroupId}
      imported={true}
      afterSave={created => {
        if (created) {
          history.push(
            `/${adAccountId}/afterCreate?type=${DashboardTypes.CREATIVE}&campaignId=${campaignId}&adGroupId=${adGroupId}`
          )
        } else {
          history.push(`/${adAccountId}/dashboard`)
        }
      }}
    />
  )
}
export default SaveAsCreative
